
var Model = require("../types/Model.js");
var xtend = require("xtend");

module.exports = Model({
	name: "managedactionsworkflow",
	init: init,
	uninit: uninit,
	triggers: triggers,
	listeners: listeners,

	_managee: null,
	_workflowId: null,
	_history: [],
	_page: 0,
	_people: {},
	_hasMore: false,

	refresh: refresh,
	recalculate: recalculate,
});

function init() {
	this._managee = null;
	this._workflowId = null;
	this._patientGroups = {};
	this.push({
		actions: [],
		ishistory: false,
		label: null
	});
}

function uninit() {
	this._patientGroups = null;
	this._managee = null;
	this._workflow = null;
	this._history = null;
	this._page = null;
	this._hasMore = false;
}

function triggers() {
	return {
		"view": view,
		"more": more,
		"reset": handle_reset,
	};
}

function listeners(){
	return {
		"managedpatientgroups:updated": handleGroupsUpdate,
		"people:updated": Model.makeRecalculator("people"),
		"connectivity:online": refresh,
	};
}

function view(data) {
	var managee = data.who;
	var workflowId = data.workflow;
	var group = data.group;
	if (!managee || !workflowId) return;
	this._managee = managee;
	this._workflowId = workflowId;
	this._group = group;

	this.refresh();

	this.emit("usermetrics:trigger:track", "view managed user's pathway actions", { pathwayId: workflowId });
}

function refresh() {
	var managee = this._managee;
	var workflowId = this._workflowId;
	var group = this._group;
	this._page = 0;

	if(!managee || !workflowId) return;

	this.emit("save:trigger:start");
	this.api.manage.workflow
		.actions(this._page, managee, workflowId, group)
		.then(handle_load.bind(this))
		.catch(console.error.bind(console))
		.then(finish_load.bind(this));
}

function handle_load(list) {
	const shouldConcat = this._history.length
		? this._history[0].ongoingWorkflow === this._workflowId
		: false;

	shouldConcat && this._page !== 0
		? (this._history = this._history.concat(list))
		: (this._history = list);

	this._hasMore = list ? list.length === 32 && list.length !== 0 : false;

	var idMap = list.reduce(addOwnerIds, {});

	this.emit("people:trigger:add", {
		who: Object.keys(idMap),
		lean: true
	});

	this.recalculate();
}

function addId(result, id){
	result[id] = true;
	return result;
}

function addOwnerIds(result, action){
	return [].concat(action.owner).reduce(addId, result);
}

function recalculate() {
	var actions = this._history;
	var people = this._people;
	const groups = this._patientGroups;

	var merged = actions.filter(function(action){
		return [].concat(action.owner).every(function(id){
			return people[id] || groups[id];
		});
	}).map(function(action){
		var ownerData = [].concat(action.owner).map(function(id){
			return people[id] || groups[id];
		});
		return xtend(action, {
			owner: ownerData
		});
	});
	this.push({
		actions: merged,
		hasMore: this._hasMore
	});
}

function handle_reset() {
	this.push([]);
}

function finish_load() {
	this.emit("save:trigger:finish");
}

function more() {
	this.emit("save:trigger:start");
	this._page++;
	this.api.manage.workflow
		.actions(this._page, this._managee, this._workflowId, this._group)
		.then(handle_load.bind(this))
		.catch(console.error.bind(console))
		.then(finish_load.bind(this));

	this.emit("usermetrics:trigger:track", "load more workflow actions", { pathwayId: this._workflowId });
}

function handleGroupsUpdate(groups){
	if(!groups || !groups.length) return;
	this._patientGroups = groups.reduce((result, group) => {
		result[group._id] = group;
		return result;
	}, {});
	this.recalculate();
}